<template>
  <basic-input-modal
    @selectedElement="propagateChange"
    :byDefault="getData()"
    :student="studentName"
    :title="title"
    ref="input"
    :options="items"/>
</template>
<script>
import BasicInputModal from './BasicInputModal.vue'
import {componentValues, getDataByValue} from '@/utils/componentsValue'

export default {
  components: { BasicInputModal },
  created: function () {
    if (this.$attrs.student) this.state = this.$attrs.student.assistence
    this.setEnable(this.state === 'asiste')
  },
  props: {
    initialValue: String,
    title: {
      type: String,
      default: () => 'Asistencia'
    },
    studentName: String
  },
  data: () => ({
    enabled: true,
    state: 'asiste',
    items: componentValues.assistence
  }),
  methods: {
    getData: function () {
      return getDataByValue(this.items, this.state)
    },
    setValue: function (value) {
      this.state = value
      this.$refs.input.setValue(this.getData())
    },
    setEnable: function (value) {
      if (value !== this.enabled) {
        this.propagateStatus(value)
        this.$refs.input.setEnable(value)
      }
    },
    propagateStatus: function (value) {
      if (value !== this.enabled) {
        this.enabled = value
        this.$emit('statusChanged', value)
      }
    },
    propagateChange: function ({item}) {
      this.state = item.value
      this.propagateStatus(this.state === 'asiste')
      this.$emit('updatedElement',
        { assistence: this.state }
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/diaryElements/Assistence.vue